var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCorteInyeccion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#GradientFill_3-4);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#GradientFill_3-5);\n      }\n\n      .cls-3 {\n        fill: url(#GradientFill_3-6);\n      }\n\n      .cls-4 {\n        fill: url(#GradientFill_3-2);\n      }\n\n      .cls-5 {\n        fill: url(#GradientFill_3-3);\n      }\n\n      .cls-6 {\n        fill: url(#GradientFill_3);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    "data-name": "GradientFill 3",
    x1: 25,
    y1: 50.14,
    x2: 25,
    y2: 0.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aa780c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d1b24a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5d06a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-2",
    "data-name": "GradientFill 3",
    x1: 22.33,
    x2: 22.33,
    y2: 0.17,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-3",
    "data-name": "GradientFill 3",
    x1: 31.11,
    x2: 31.11,
    y2: 0.17,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-4",
    "data-name": "GradientFill 3",
    x1: 33.42,
    x2: 33.42,
    y2: 0.17,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-5",
    "data-name": "GradientFill 3",
    x1: 35.66,
    y1: 50.14,
    x2: 35.66,
    y2: 0.17,
    xlinkHref: "#GradientFill_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3-6",
    "data-name": "GradientFill 3",
    x1: 19.86,
    x2: 19.86,
    y2: 0.17,
    xlinkHref: "#GradientFill_3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M25,0C11.22,0,0,11.21,0,25s11.22,25,25,25,25-11.21,25-25S38.78,0,25,0ZM46.94,25c0,5.51-2.05,10.55-5.42,14.41L10.59,8.47c3.86-3.37,8.9-5.42,14.41-5.42,12.1,0,21.94,9.84,21.94,21.94ZM3.06,25c0-5.48,2.02-10.5,5.36-14.35l30.93,30.93c-3.85,3.33-8.86,5.36-14.35,5.36-12.1,0-21.94-9.84-21.94-21.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.63,15.35h5.14c.14,0,.25.11.25.25v5.14l2.31,2.31v-7.45c0-1.41-1.15-2.56-2.56-2.56h-7.45l2.31,2.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.05,25.88v1.88l2.31,2.31v-5.34c0-.64-.52-1.15-1.15-1.15h-5.34l2.31,2.31h1.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.35,36.76c.4.97,1.18,1.75,2.15,2.15l-2.15-2.15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.56,15.65v5.57c0,.64.52,1.15,1.15,1.15h.95v11.01l2.27,2.27c.01-.13.04-.26.04-.39v-18.25c0-.33-.14-.64-.39-.86l-2.1-1.87s0,0,0,0l-4.21-3.74c-.48-.42-1.21-.38-1.63.1-.42.48-.38,1.21.1,1.63l3.82,3.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.99,36.91h-1.65v-5.16l-2.31-2.31v7.47h-10.33v-17.79l-2.31-2.31v20.1h-1.65c-.64,0-1.15.52-1.15,1.15s.52,1.15,1.15,1.15h18.25c.64,0,1.15-.52,1.15-1.15s-.52-1.15-1.15-1.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorteInyeccion);
export default __webpack_public_path__ + "static/media/Icon_CorteInyeccion.7c79c3180cf21bc2d2ea6aa1082914ca.svg";
export { ForwardRef as ReactComponent };